import {
  useMutation,
  UseMutationResult,
  useQueryClient,
} from '@tanstack/react-query'
import { useApiClient } from '@/hooks'
import { unwrapErrorResponse, unwrapResponse } from '@/utils'
import {
  APIErrorResponse,
  InternalHoursLog,
  PutInternalHoursLog,
} from '@/types'
import { getUseInternalHoursLogsKey } from './useInternalHoursLogs'
import { getUseInternalHoursBalanceKey } from './useInternalHoursBalance'

export const usePutInternalHoursLog = (
  id: number
): UseMutationResult<
  InternalHoursLog,
  APIErrorResponse,
  PutInternalHoursLog
> => {
  const client = useApiClient()
  const queryClient = useQueryClient()
  const listKey = getUseInternalHoursLogsKey()
  const balanceKey = getUseInternalHoursBalanceKey()

  return useMutation(
    (params) =>
      client
        .put(`/hours_reporting/internal-hours/${id}/`, params)
        .then(unwrapResponse)
        .catch(unwrapErrorResponse),
    {
      onSuccess: async () => {
        await Promise.all([
          queryClient.invalidateQueries(listKey),
          queryClient.invalidateQueries(balanceKey),
        ])
      },
    }
  )
}
